import Box from '@mui/material/Box';
import { DetailsSkeleton } from 'common/components/DetailsSkeleton';

type SectionLoaderPorps = {
  children: React.ReactNode;
  isLoading?: boolean;
  'data-testid'?: string;
};

export const SectionLoader = ({
  children,
  isLoading,
  'data-testid': dataTestId,
}: SectionLoaderPorps) => {
  if (isLoading) {
    return (
      <Box
        data-testid={dataTestId}
        sx={{ borderTop: ({ palette }) => `1px solid ${palette.border}`, pt: 16 }}
      >
        <DetailsSkeleton numberOfRepetitions={1} />
      </Box>
    );
  }

  return children;
};
